import { convertOwi } from "@nova-rnd/sensortool-wasm"
import { defineTask } from "@nova/webworker-pool"
import { initializeSensorToolFromModule } from "integrations/sensortool"
import type { MmaCsvRow } from "./parseMmaCsv"

export const convertOwiWithCsv = defineTask({
    name: "convertOwiWithCsv",
    wasm: ["sensortool"],
    run: async ({ buffer, csvRow }: { buffer: ArrayBuffer; csvRow: MmaCsvRow }, { wasm }) => {
        initializeSensorToolFromModule(wasm.sensortool)
        try {
            const result = convertOwi(new Uint8Array(buffer), csvRow)
            const tiffBuffer = result.bytes.buffer as ArrayBuffer
            const outcome = {
                data: { tiffBuffer, extension: result.extension, mimeType: result.mimeType },
                transfer: [tiffBuffer],
            }
            result.free()
            return outcome
        } catch (error) {
            console.warn("convertOwiWithCsv: failed", error)
            return { data: undefined }
        }
    },
})
